import Vue from 'vue';

// 独立出处理函数，方便使用 nextTick
function handleEllipsis(el) {
    // 使用 nextTick 确保 DOM 和 CSS 已经完全渲染计算完毕
    Vue.nextTick(() => {
        const textNodes = el.querySelectorAll('.el-select__tags-text');

        if (textNodes && textNodes.length > 0) {
            textNodes.forEach(node => {
                // 判断是否溢出
                if (node.scrollWidth > node.clientWidth) {
                    node.setAttribute('title', node.innerText);
                } else {
                    node.removeAttribute('title');
                }
            });
        }
    });
}
export default {
    install(Vue) {
        // 注册全局指令
        Vue.directive('ellipsis-title', {
            // 第一次绑定到元素时调用
            inserted(el) {
                handleEllipsis(el);
            },
            // 所在组件的 VNode 更新时调用
            componentUpdated(el) {
                handleEllipsis(el);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/units/directive/ellipsisTitle.js